import { create } from 'zustand';

interface FeedbackModalStore {
    isOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
}

export const useFeedbackModalStore = create<FeedbackModalStore>((set) => ({
    isOpen: false,
    openModal: () => set({ isOpen: true }),
    closeModal: () => set({ isOpen: false }),
}));
